import React from "react";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./SkeletonBrandCard.module.css"; // CSS 모듈 임포트

function SkeletonBrandCard(isDummy) {
    return (
        <div
            style={{
                display: "flex",
                flex: "1 0 30%",
                justifyContent: "center",
                alignItems: "center",
                height: "340px",
                visibility: isDummy ? 'hidden' : 'visible'
            }}
        >
            <VerticalFlex>
                <FlexChild borderRadius={"3px"}>
                    {/* 이미지 부분에 스켈레톤 클래스 적용 */}
                    <div
                        className={style.skeleton}
                        style={{ width: "100%", height: "223px", borderRadius: "3px" }}
                    ></div>
                </FlexChild>
                <FlexChild border={"1px solid rgba(165, 165, 165, 1)"}>
                    <HorizontalFlex width={"95%"} alignItems={"center"}>
                        <FlexChild width={"85%"}>
                            <VerticalFlex flexStart gap={15}>
                                <FlexChild>
                                    {/* 제목 부분에 스켈레톤 클래스 적용 */}
                                    <div
                                        className={style.skeleton}
                                        style={{ width: "50%", height: "20px" }}
                                    ></div>
                                </FlexChild>
                                <FlexChild>
                                    {/* 부제목 부분에 스켈레톤 클래스 적용 */}
                                    <div
                                        className={style.skeleton}
                                        style={{ width: "50%", height: "30px" }}
                                    ></div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            {/* 아이콘 부분에 스켈레톤 클래스 적용 */}
                            <div
                                className={style.skeleton}
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                            ></div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </div>
    );
}

export default SkeletonBrandCard;
